export const SET_LOCATION = 'SET_LOCATION'
export const PUSH_LOCATIONS = 'PUSH_LOCATIONS'
export const SET_LOADING_MORE_LOCATION = 'SET_LOADING_MORE_LOCATION'
export const SET_LOCATION_LIST_REQUEST = 'SET_LOCATION_LIST_REQUEST'
export const SET_LOCATION_LIST_REACH_BOTTOM = 'SET_LOCATION_LIST_REACH_BOTTOM'
